import StoryblokImage from "./StoryblokImage";

export default StoryblokImage;
